import { v4 as uuidv4 } from 'uuid';

export function deleteInSubscribedSchedules({ subscription, schedule }) {
    this.subscriptions = this.subscriptions.map((item) => {
        if (item.id === subscription.id) {
            item.subscribedSchedules = (item.subscribedSchedules || []).filter(
                (schItem) => schItem.scheduleId !== schedule.scheduleId
            );
        }
        return item;
    });

    // Keep connectedSchedules map in sync — it's the derived snapshot used by the UI
    this.connectedSchedules[subscription.id] = (this.connectedSchedules[subscription.id] || []).filter(
        (s) => s.scheduleId !== schedule.scheduleId
    );

    this.observed.subscriptions = uuidv4();
}
